import cx from "clsx";
import type React from "react";
import Styles from "./ModalFooter.module.scss";

type Props = {
	acceptLabel?: string;
	bottomSticky?: boolean;
	isSubmitting?: boolean;
	onClickAccept: () => void | boolean | Promise<boolean> | Promise<void>;
	onClickCancel: () => void;
	submitInvalid?: boolean;
};

export const ModalFooter: React.FC<Props> = ({
	isSubmitting = false,
	submitInvalid = false,
	onClickCancel,
	onClickAccept,
	acceptLabel = "保存",
	bottomSticky = true
}: Props) => (
	<div
		className={cx(Styles.ModalFooter, bottomSticky ? Styles.BottomSticky : "")}
	>
		<button
			className={Styles.CancelButton}
			disabled={isSubmitting}
			onClick={onClickCancel}
			type="button"
		>
			キャンセル
		</button>
		<button
			className={Styles.SubmitButton}
			disabled={isSubmitting || submitInvalid}
			onClick={onClickAccept}
			type="button"
		>
			{acceptLabel}
		</button>
	</div>
);
